/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Property_Applied_B_To_AInputs */



/**
* | output |
* | --- |
* | "Property applied from Group B to Group A" |
*
* @param {Compare_Event_Groups_Property_Applied_B_To_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_property_applied_b_to_a = /** @type {((inputs?: Compare_Event_Groups_Property_Applied_B_To_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Property_Applied_B_To_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Propriété transférée du groupe B au groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigentum, das von Gruppe B zu Gruppe A übertragen wurde")
	if (locale === "it") return /** @type {LocalizedString} */ ("Beni trasferiti dal Gruppo B al Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имущество, перенесенное из группы B в группу A.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Propiedad aplicada del Grupo B al Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从B组到A组的属性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBからグループAに適用される資産")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह बी से समूह ए में स्थानांतरित की गई संपत्ति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Propriedade transferida do Grupo B para o Grupo A")
	return /** @type {LocalizedString} */ ("Property applied from Group B to Group A")
});